module.exports = __webpack_public_path__ + "img/pathologie.e41a2eba.jpg";